import React, { useContext } from "react";
import { AppContext } from "../shared/context/AppContext";

function convertMs(timeInMs) {
  let hours = Math.floor((timeInMs / (1000 * 60 * 60)) % 60);
  let minutes = Math.floor((timeInMs / (1000 * 60)) % 60);
  let seconds = Math.floor((timeInMs / 1000) % 60);
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  return `${hours}:${minutes}:${seconds}`;
}

function KlassementTable({ data, limit }) {
  const { language } = useContext(AppContext);
  const nl = language === "NL";
  // Fastest first; copy so the caller's data is left alone
  const sorted = [...data]
    .sort((a, b) => a.totaltime - b.totaltime)
    .slice(0, limit);

  if (sorted.length === 0) {
    return (
      <div className="ranking-card ranking-empty">
        <div className="ranking-empty-icon" aria-hidden="true">
          🏆
        </div>
        <p>{nl ? "Nog geen teams gefinisht." : "No teams have finished yet."}</p>
      </div>
    );
  }

  return (
    <div className="ranking-card">
      <table className="ranking-table">
        <thead>
          <tr>
            <th scope="col" className="rank-col">
              #
            </th>
            <th scope="col">Team</th>
            <th scope="col" className="time-col">
              {nl ? "Tijd" : "Time"}
            </th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((team, index) => (
            <tr
              key={index}
              className={index < 3 ? `podium podium-${index + 1}` : undefined}
            >
              <td className="rank-col">
                <span className="rank-badge">{index + 1}</span>
              </td>
              <td className="team-col">{team.teamname}</td>
              <td className="time-col">{convertMs(team.totaltime)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default KlassementTable;
